import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { AsyncButton, SaveStates, Tooltip } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { Box, Button, buttonClasses } from '@mui/material';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LinkCard from '../link-card';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var OnlineStage = function OnlineStage(_ref) {
  var _ref3;

  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      completeStageStatus = _ref.completeStageStatus,
      incompleteTooltipText = _ref.incompleteTooltipText,
      prospect = _ref.prospect;
  var previewDescription = stage.previewDescription,
      previewImageUrl = stage.previewImageUrl,
      previewTitle = stage.previewTitle,
      previewHideImage = stage.previewHideImage,
      url = stage.url;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      completed = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      setComplete = _useToggle2$.on,
      setIncomplete = _useToggle2$.off;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(setIncomplete, [stage.id]);
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsx(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex'
      },
      children: [/*#__PURE__*/_jsx(Button, {
        sx: (_ref3 = {
          mx: 1
        }, _defineProperty(_ref3, "&.".concat(buttonClasses.contained, ":visited"), {
          color: function color(t) {
            return t.palette.primary.contrastText;
          }
        }), _defineProperty(_ref3, "&.".concat(buttonClasses.text, ":visited"), {
          color: function color(t) {
            return t.palette.primary.main;
          }
        }), _ref3),
        size: "large",
        variant: completed ? 'text' : 'contained',
        href: url !== null && url !== void 0 ? url : '',
        onClick: setComplete,
        target: "_blank",
        rel: "noopener noreferrer",
        children: stage.ctaButtonText || t('Visit site')
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: completed ? '' : t(incompleteTooltipText),
        arrow: true,
        disableFocusListener: true,
        children: /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(AsyncButton, {
            status: mutationValue,
            text: ['Submitting...', 'Saved', stage.completionText || 'Next', stage.completionText || 'Next'],
            disabled: !completed,
            onClick: function onClick() {
              return pipe(stage.__typename === 'OnlineActionStage' ? 'onlineActionInput' : 'reviewInput', function (responseType) {
                return completeStage(_defineProperty({}, responseType, {
                  stageID: stage.id,
                  activityID: activity === null || activity === void 0 ? void 0 : activity.id
                }));
              });
            },
            variant: completed ? 'contained' : 'text'
          })
        })
      })]
    }),
    "data-element": "StageLayout",
    "data-component": "OnlineStage",
    "data-source-file": "index.tsx",
    children: url ? /*#__PURE__*/_jsx(LinkCard, {
      previewDescription: previewDescription,
      previewImageUrl: previewImageUrl,
      previewTitle: previewTitle,
      previewHideImage: previewHideImage,
      url: url,
      onClick: setComplete
    }) : null
  });
};

export default OnlineStage;